export default {
  ru: {
    support_service: 'Служба поддержки',
    first_name: 'Имя',
    description: 'Описание',
    send_message: 'Ваше обращение успешно отправлено'
  },
  en: {
    support_service: 'Support service',
    first_name: 'First Name',
    description: 'Description',
    send_message: 'Your request has been successfully sent'
  }
}